import { render } from "./AttachmentTypeCard.vue?vue&type=template&id=25128126"
import script from "./AttachmentTypeCard.vue?vue&type=script&lang=js"
export * from "./AttachmentTypeCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__